const autocompleteFormParamUser = {
  sites: 'Sites',
  companies: 'Third party company'
};

export default autocompleteFormParamUser;
